module.exports = __webpack_public_path__ + "static/media/kite_surfing_1600.d6900e50.webp";